"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var StyledReactTooltip = (0, styled_components_1.default)(react_tooltip_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t&.tws-tooltip {\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t}\n"], ["\n\t&.tws-tooltip {\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t}\n"])), function (props) {
    return (props.type === undefined || props.type === 'info') &&
        "\n\t\t\t\tbackground: #111111;\n\t\t\t";
}, function (props) {
    return props.theme.theme === 'compact' &&
        "\n\t\t\t\tpadding: 10px;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tmax-height: 300px;\n\t\t\t\tz-index: 2000;\n\t\t\t\tpointer-events: auto;\n\t\t\t\topacity: 1;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 1.4em;\n\t\t\t";
}, function (props) { return props.theme.theme === 'custom' && props.theme.customStyles; }, function (props) {
    return (props.theme.theme === undefined || props.theme.theme === 'default') &&
        "\n\t\t\t\tpadding: 25px;\n\t\t\t\twidth: 300px;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tmax-height: 300px;\n\t\t\t\tz-index: 2000;\n\t\t\t\tpointer-events: auto;\n\t\t\t\topacity: 1;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 1.4em;\n\t\t\t";
});
var StyledReactTooltipContainer = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&.tws-tooltip-container {\n\t\tmargin: 0 5px;\n\t}\n\t&.tws-tooltip-container ul {\n\t\tlist-style-type: disc;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t}\n\t&.tws-tooltip-container ul li {\n\t\tmargin: 0 0 0 18px;\n\t}\n"], ["\n\t&.tws-tooltip-container {\n\t\tmargin: 0 5px;\n\t}\n\t&.tws-tooltip-container ul {\n\t\tlist-style-type: disc;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t}\n\t&.tws-tooltip-container ul li {\n\t\tmargin: 0 0 0 18px;\n\t}\n"])));
var StyledTextContainer = styled_components_1.default.div.attrs({ className: 'hide-overflow' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t&.hide-overflow {\n\t\toverflow-y: auto;\n\t\twidth: 100%;\n\t\tmax-height: 250px;\n\t}\n"], ["\n\t&.hide-overflow {\n\t\toverflow-y: auto;\n\t\twidth: 100%;\n\t\tmax-height: 250px;\n\t}\n"])));
// TODO: Set character limit to 350
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        return _super.call(this, props) || this;
    }
    Tooltip.prototype.render = function () {
        return this.content();
    };
    Tooltip.prototype.content = function () {
        var html = this.props.children;
        if (!html) {
            return React.createElement("span", null);
        }
        return (React.createElement(StyledReactTooltipContainer, { className: 'tws-tooltip-container', "data-tip": '', "data-for": this.props.id, "data-effect": 'solid', "data-scroll-hide": 'false' },
            this.getIcon(),
            React.createElement(StyledReactTooltip, __assign({}, this.props, { id: this.props.id, delayShow: 1000, delayHide: 500, place: this.props.placement, role: 'tooltip', className: 'tws-tooltip' }),
                React.createElement(StyledTextContainer, null, this.props.children))));
    };
    Tooltip.prototype.getIcon = function () {
        var iconName = this.props.iconName || 'info';
        // NOTE: using a styled icon is not the same as passing styles to the original component.
        // This is necessary in order to override the color for inverted icon colors.
        var style = {
            fontSize: '14px',
            color: this.props.inverted ? globalVars_module_scss_1.default.white : globalVars_module_scss_1.default.gray3,
            cursor: 'pointer',
        };
        return this.props.leaveIconStyle ? (React.createElement(Common_1.Icon, { "aria-label": iconName, name: iconName })) : (React.createElement(Common_1.Icon, { "aria-label": iconName, name: iconName, style: style }));
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
var templateObject_1, templateObject_2, templateObject_3;
